module.exports = __webpack_public_path__ + "img/boat-icon.50308d21.svg";